import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';

import {
  coursePauseRequest,
  coursePauseRequestFilter,
} from 'features/courseResume';
import { recordingRequest } from 'features/recording';
import {
  createClassFormReducer,
  deleteSbatGroupReducer,
  editClassesReducer,
  editCrashCourseBatchReducer,
  editSbatGroupReducer,
  rescheduleClassesFilterReducer,
  rescheduleClassesFormReducer,
  rescheduleSbatGroupReducer,
  scheduleClassesFormReducer,
  sbatGroupBulkUpdateReducer,
  sbatGroupBulkUpdateFilterReducer,
} from 'features/classCreation';
import {
  blacklistLearnersReducer,
  blacklistLearnersFilterReducer,
} from 'features/communicationManagement';
import { creditManagementReducer } from 'features/creditManagement';
import {
  superBatchModuleReducer,
  updateMenteeModuleReducer,
} from 'features/moduleManagement';
import { uploadVideoReducer } from 'features/assetManagement';
import { capstoneSubmissionReducer } from 'features/neovarsityManagement';
import { superBatchGroupModuleReducer } from 'features/satManagement';
import { superBatchManagementReducer } from 'features/superBatchManagement';
import baseScmService from 'services/baseScmService';
import permissionsService from 'services/permissionsService';
import Sentry from 'Sentry';

const store = configureStore({
  reducer: {
    [baseScmService.reducerPath]: baseScmService.reducer,
    [permissionsService.reducerPath]: permissionsService.reducer,
    blacklistLearners: blacklistLearnersReducer,
    blacklistLearnersFilter: blacklistLearnersFilterReducer,
    creditManagement: creditManagementReducer,
    capstoneSubmission: capstoneSubmissionReducer,
    coursePauseRequest: coursePauseRequest,
    coursePauseRequestFilter: coursePauseRequestFilter,
    createClassForm: createClassFormReducer,
    deleteSbatGroup: deleteSbatGroupReducer,
    editCrashCourseBatch: editCrashCourseBatchReducer,
    editClasses: editClassesReducer,
    editSbatGroup: editSbatGroupReducer,
    recordingRequest: recordingRequest,
    rescheduleClassesFilter: rescheduleClassesFilterReducer,
    rescheduleClassesForm: rescheduleClassesFormReducer,
    rescheduleSbatGroup: rescheduleSbatGroupReducer,
    scheduleClassesForm: scheduleClassesFormReducer,
    sbatGroupBulkUpdateFilter: sbatGroupBulkUpdateFilterReducer,
    sbatGroupBulkUpdate: sbatGroupBulkUpdateReducer,
    superBatchGroupModule: superBatchGroupModuleReducer,
    superBatchManagement: superBatchManagementReducer,
    updateMenteeModule: updateMenteeModuleReducer,
    superBatchModule: superBatchModuleReducer,
    uploadVideo: uploadVideoReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      baseScmService.middleware,
      permissionsService.middleware,
      Sentry.reduxUnhandledErrorReporter,
    ]),
});

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;

export default store;
